module.exports = __webpack_public_path__ + "static/media/cover2.1e8e1af6.png";